module.exports = __webpack_public_path__ + "static/about-us-our-audience-photo@2x-4de0618a59cca2d9f06de942a7ba994f.jpg";